// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LumeTheme__modal-body___3CL7a {
  --_apc-modal-body-color: var(--lume-g-color-text-primary);
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/components/ModalBody/themes/LumeTheme.css"],"names":[],"mappings":"AAAA;EACE,yDAAyD;AAC3D","sourcesContent":[".LumeTheme__modal-body___3CL7a {\n  --_apc-modal-body-color: var(--lume-g-color-text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
